import { useIsBrandPreview } from "@faire/retailer-visitor-shared/lib/getIsBrandPreview";
import { getSettingTopShopRetailerExperienceEnabledByRegion } from "@faire/retailer/settings/getSettingTopShopRetailerExperienceEnabledByRegion";

interface ITopShopVisibility {
  /**
   * Whether TOP_SHOP_RETAILER_EXPERIENCE_ENABLED_BY_REGION_220322 is on
   */
  isTopShopEnabled: boolean;

  /**
   * Whether Top Shop content should be visible outside the context of a brand
   */
  isTopShopContentVisible: boolean;

  /**
   * Whether Top Shop content should be visible in the context of a brand
   */
  isTopShopContentVisibleForBrand: boolean;
}

export const useTopShopVisibility = (
  isBrandTopShop: boolean = false
): ITopShopVisibility => {
  const isTopShopEnabled = getSettingTopShopRetailerExperienceEnabledByRegion();

  const isBrandPreview = useIsBrandPreview();
  return getTopShopVisibility(isTopShopEnabled, isBrandTopShop, isBrandPreview);
};

export const getTopShopVisibility = (
  isTopShopEnabled: boolean,
  isBrandTopShop: boolean,
  isBrandPreview: boolean
): ITopShopVisibility => {
  const isTopShopContentVisible = isTopShopEnabled || isBrandPreview;

  const isTopShopContentVisibleForBrand =
    isTopShopContentVisible && isBrandTopShop;

  return {
    isTopShopEnabled,
    isTopShopContentVisible,
    isTopShopContentVisibleForBrand,
  };
};
